module.exports = __webpack_public_path__ + "static/media/404_image.459caf2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/404_image.png
// module id = 390
// module chunks = 0